module.exports = __webpack_public_path__ + "static/img/authenticate-icon.1c90cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/authenticate-icon.png
// module id = 4lfg
// module chunks = 2